export const getQueryParams = <T extends Record<string, any>>(options: T): string =>
  options
    ? Object.keys(options)
        .filter((key) => options[key])
        .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(options[key]))
        .join("&")
    : ""
